import { Link } from "react-router";
import { useAuthStore } from "../../stores/auth.store";

export function Header() {
  const user = useAuthStore((s) => s.user);
  const isLoading = useAuthStore((s) => s.isLoading);

  return (
    <header className="sticky top-0 z-50 border-b border-gray-200 bg-white">
      <div className="mx-auto flex h-14 max-w-5xl items-center justify-between px-4">
        <Link to="/" aria-label="Abejón home" className="text-xl font-bold tracking-tight focus-visible:ring-2 focus-visible:ring-gray-900 focus-visible:ring-offset-2 rounded">
          Abejón
        </Link>
        <nav aria-label="Main navigation" className="hidden items-center gap-4 sm:flex">
          <Link
            to="/explore"
            className="text-sm font-medium text-gray-600 hover:text-gray-900"
          >
            Explore
          </Link>
          {isLoading ? (
            <div className="h-8 w-8 rounded-full bg-gray-200 animate-pulse" />
          ) : user ? (
            <>
              {user.accountType === "business" && (
                <>
                  <Link
                    to="/dashboard/bookings"
                    className="text-sm font-medium text-gray-600 hover:text-gray-900"
                  >
                    Bookings
                  </Link>
                  <Link
                    to="/dashboard/services"
                    className="text-sm font-medium text-gray-600 hover:text-gray-900"
                  >
                    Services
                  </Link>
                  <Link
                    to="/dashboard/posts"
                    className="text-sm font-medium text-gray-600 hover:text-gray-900"
                  >
                    Posts
                  </Link>
                  <Link
                    to="/dashboard/schedule"
                    className="text-sm font-medium text-gray-600 hover:text-gray-900"
                  >
                    Schedule
                  </Link>
                  <Link
                    to="/dashboard/settings"
                    className="text-sm font-medium text-gray-600 hover:text-gray-900"
                  >
                    Settings
                  </Link>
                </>
              )}
              <Link
                to="/account"
                aria-label="My account"
                className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-900 text-sm font-medium text-white focus-visible:ring-2 focus-visible:ring-gray-900 focus-visible:ring-offset-2"
              >
                {user.name.charAt(0).toUpperCase()}
              </Link>
            </>
          ) : (
            <Link
              to="/login"
              className="rounded-lg bg-gray-900 px-4 py-2 text-sm font-medium text-white hover:bg-gray-800"
            >
              Log in
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
}
